import { create } from 'zustand';
import { authApi } from '@/services/api';
import { ROUTES } from '@/routes';

interface AuthState {
  user: any | null;
  isLoading: boolean;
  isAuthenticated: boolean;
  fetchUser: () => Promise<void>;
  logout: () => Promise<void>;
}

const publicPaths: string[] = [ROUTES.home, ROUTES.login];

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  isLoading: true,
  isAuthenticated: false,

  fetchUser: async () => {
    if (publicPaths.includes(window.location.pathname)) {
      set({ user: null, isAuthenticated: false, isLoading: false });
      return;
    }
    try {
      const response = await authApi.getMe();
      set({ user: response.data, isAuthenticated: true, isLoading: false });
    } catch {
      set({ user: null, isAuthenticated: false, isLoading: false });
    }
  },

  logout: async () => {
    await authApi.logout();
    set({ user: null, isAuthenticated: false });
    window.location.href = ROUTES.home;
  },
}));
